<template
    xmlns:nd-route="http://www.w3.org/1999/xhtml">
  <el-card>
    <div
        slot="header"
        class="clearfix">
      <span class="header-item">Third Party Devices</span>
    </div>
    <div class="card-content device-list">
      <div
          style="min-height: 100px;">
        <el-table
            class="table__header-subtitles"
            :row-class-name="'device-table-row-style'"
            :cell-class-name="'device-table-cell-style'"
            :data="thirdPartyDevices"
            :highlight-current-row="false">
          <el-table-column min-width="90">
            <template slot-scope="scope">
              <div style="text-align: center;">
                <DeviceImage
                    :device="scope.row" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
              min-width="160"
              label="Device">
            <template slot-scope="scope">
              <div style="padding-left: 10px">
                <div style="border-bottom: solid 1px #ddd; margin-bottom: 10px; padding-bottom: 10px;">
                  {{ scope.row.name }}
                  <br>
                  <span style="color: #999">{{ (product(scope.row).description || scope.row.type) | capitalize }}</span>
                </div>
                <div class="device-column">
                  <div style="position: relative">
                    <el-link
                        type="primary"
                        target="_blank"
                        :underline="false"
                        :href="scope.row.ring_solutions_url">
                      {{ deviceLinkText(scope.row) }}
                    </el-link>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              min-width="200"
              label="Owner">
            <template
                slot-scope="scope">
              <div
                  slot="content"
                  class="flex items-start">
                <span class="owner-email">{{ scope.row.owner_email }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              min-width="300"
              label="Created At">
            <template
                slot-scope="scope">
              <div
                  slot="content"
                  class="flex items-start">
                <time-zone-formatter :current-time="scope.row.created_at" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
              min-width="300"
              label="Updated At">
            <template
                slot-scope="scope">
              <div
                  slot="content"
                  class="flex items-start">
                <time-zone-formatter :current-time="scope.row.updated_at" />
              </div>
            </template>
          </el-table-column>
          <el-table-column
              min-width="220">
            <template slot-scope="scope">
              <div
                  slot="content"
                  class="flex flex-col items-start">
              </div>
            </template>
          </el-table-column>
          <el-table-column min-width="120">
            <template slot="header">
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </el-card>
</template>

<script>
import { get } from "lodash";
import DeviceImage from "@/components/Shared/DeviceImage";

/* ---------------------
 * Import from the Store
 * --------------------- */
import { createNamespacedHelpers } from "vuex";
const { mapGetters: devicesGetters } = createNamespacedHelpers("db/devices");
const { mapGetters: sharedGetters } = createNamespacedHelpers("shared");

/* ---------------------
 *    Vue Component
 * --------------------- */

export default {
  name: "ThirdPartyDevices",
  components: { DeviceImage },
  computed: {
    ...sharedGetters(["products"]),
    ...devicesGetters(["thirdPartyDevices"]),
  },
  methods: {
    deviceLinkText(data) {
      return (
        get(data, "mac_address", null) ||
        get(data, "hardware_id", null) ||
        get(data, "doorbot_id", "ID not found")
      );
    },
    product(device) {
      return this.products.find((p) => p.kind === device.type) || {};
    },
  },
};
</script>

<style lang="scss">
$color-opacity: opacity(0.9);
.warranty-indicator {
  width: 10px;
  height: 10px;
  background: #ccc;
  border: solid 1px transparent;
  border-radius: 100%;
  float: left;
  margin: 6px 5px 0px 0px;
}

.warranty-status {
  margin-top: 5px;
  cursor: pointer;
  font-size: 13px;
  align-items: center;
}

.el-table__body tr.hover-row > td,
.el-table__body tr.hover-row.current-row > td {
  background-color: inherit;
}

.el-table__body tr.hover-row.el-table__row--striped > td,
.el-table__body tr.hover-row.el-table__row--striped.current-row > td {
  background-color: #fafafa;
}

.device-table-cell-style {
  .cell {
    padding: 0px 10px;
  }
}

.device-table-row-style {
  .cell {
    word-break: break-word;
    padding: 0;
    padding-top: 7px;
    padding-left: 7px;
    min-height: 15vh;
    max-height: 40vh;
  }
}

.device-list .disabled {
  color: #d6d6d6;
}

.device-list .danger {
  color: #f56c6c;
}

.device-list .replace_process {
  color: #e6a23c;
}

.device-list .active {
  color: #67c23a;
}

.device-list .returned {
  color: #f56c6c;
}

.device-list {
  .offline-device__icon {
    color: $--color-milano-red;
    filter: $color-opacity;
  }

  .online-device__icon {
    color: $--color-fun-green;
    filter: $color-opacity;
  }
}

table {
  .column-x1 {
    width: 5% !important;
  }

  .column-x2 {
    width: 10% !important;
  }

  .column-x3 {
    width: 15% !important;
  }

  .column-x4 {
    width: 25% !important;
  }
}
</style>
